import { useContext } from 'react';
import { uniqueId } from '../../utils/uniqueId';
import styled from 'foundations-theming/utils';
import { TypeaheadContext } from './TypeaheadContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledGroupLabel = styled.div.withConfig({
  displayName: "TypeaheadResultsGroup__StyledGroupLabel",
  componentId: "sc-3xukis-0"
})(({
  theme
}) => {
  return Object.assign({}, theme.typography['heading-50'], {
    paddingInline: theme.space['500'],
    paddingBlockStart: theme.space['300'],
    paddingBlockEnd: theme.space['200'],
    // truncate-text helper class styles
    hyphens: 'none',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%'
  });
});
const StyledGroupList = styled.ul.withConfig({
  displayName: "TypeaheadResultsGroup__StyledGroupList",
  componentId: "sc-3xukis-1"
})(({
  theme
}) => {
  return {
    listStyle: 'none',
    marginBlockEnd: theme.space['0'],
    paddingInlineStart: theme.space['0']
  };
});
const StyledGroupListItem = styled.li.withConfig({
  displayName: "TypeaheadResultsGroup__StyledGroupListItem",
  componentId: "sc-3xukis-2"
})(({
  $typeaheadResultsGroupStyleOverrides
}) => {
  return $typeaheadResultsGroupStyleOverrides;
});
export const TypeaheadResultsGroup = ({
  group,
  children
}) => {
  var _useContext$typeahead, _useContext;
  const typeaheadResultsGroupStyleOverrides = (_useContext$typeahead = (_useContext = useContext(TypeaheadContext)) === null || _useContext === void 0 ? void 0 : _useContext.typeaheadResultsGroupStyleOverrides) !== null && _useContext$typeahead !== void 0 ? _useContext$typeahead : {};
  const id = uniqueId('typeahead-results-group-');
  const GroupIcon = group.icon;
  const computedLabel = group.text || String(group.value);
  return /*#__PURE__*/_jsxs(StyledGroupListItem, {
    role: "presentation",
    $typeaheadResultsGroupStyleOverrides: typeaheadResultsGroupStyleOverrides,
    children: [/*#__PURE__*/_jsxs(StyledGroupLabel, {
      "aria-hidden": true,
      id: id,
      title: group.title || computedLabel,
      children: [GroupIcon ? /*#__PURE__*/_jsx(GroupIcon, {}) : null, " ", computedLabel]
    }), /*#__PURE__*/_jsx(StyledGroupList, {
      "aria-labelledby": id,
      role: "listbox",
      children: children
    })]
  });
};